import { BasicEvent } from "./BasicEvent";
export class ArbetsorderDokumentUpdatedEventMessage extends BasicEvent {
    arbetsorderId: number;
    filnamn: string;
    typ: string;
    format: string;
    skapadTid: Date;
    storlek: number;
    dokumentnyckel: string;
    virkesorderNr: string;
    maskinnummer: string;
    stanForD2010Version: string;
    dokumentState: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderDokumentUpdatedEventMessage";
}
